import { useId, useState } from 'react'
import { errorMessage } from '../api.ts'
import { login } from '../auth.ts'
import { OrbisMark } from '../components/Topbar.tsx'
import { Button, Field } from '../components/ui.tsx'
import { useBusy } from '../lib/hooks.ts'

export function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, run] = useBusy()
  const ids = { email: useId(), password: useId(), error: useId() }

  const submit = () =>
    run(async () => {
      setError(null)
      try {
        await login(email.trim(), password)
      } catch (e) {
        setError(errorMessage(e))
      }
    })

  return (
    <main className="flex min-h-full items-center justify-center bg-bg px-4 py-10">
      <div className="w-full max-w-[360px]">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="flex items-center gap-2.5">
            <OrbisMark className="h-8 w-8" />
            <span className="text-[20px] font-bold tracking-[-0.01em]">Orbis</span>
            <span className="h-5 w-px bg-line-strong" aria-hidden="true" />
            <span className="text-[19px] font-semibold text-muted">OMA</span>
          </div>
          <p className="mt-3 text-[14px] text-muted">One Man Army — пульт управления агентами</p>
        </div>
        <form
          className="panel flex flex-col gap-4 px-6 py-6"
          onSubmit={(e) => {
            e.preventDefault()
            void submit()
          }}
          aria-describedby={error ? ids.error : undefined}
        >
          <Field label="Почта" htmlFor={ids.email}>
            {/* 16px на телефоне: иначе iPhone Safari приближает страницу при вводе, и после входа она остаётся шире экрана */}
            <input
              id={ids.email}
              className="ctl h-10 max-md:text-[16px]"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </Field>
          <Field label="Пароль" htmlFor={ids.password}>
            <input
              id={ids.password}
              className="ctl h-10 max-md:text-[16px]"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Field>
          {error ? (
            <div id={ids.error} role="alert" className="rounded-ctl bg-danger-soft px-3 py-2 text-[13px] break-words text-danger">
              {error}
            </div>
          ) : null}
          <Button type="submit" variant="primary" className="h-10" loading={busy} disabled={!email || !password}>
            Войти
          </Button>
        </form>
      </div>
    </main>
  )
}
